<template>
  <div>
    <div class="row margin-half-top">
      <div class="col-md-12">
        <div class="">
          <div class="card-header">

            <btn-rounded label="DADOS CADASTRAIS" event="showView" params="profile" :fill="activeView === 'profile'" />

            <btn-rounded label="DEPENDENTES" event="showView" params="dependent" :fill="activeView === 'dependent'" />

            <btn-rounded label="SALÁRIO" event="showView" params="salary" :fill="activeView === 'salary'" />

            <btn-rounded label="CARTÕES DE CRÉDITO" event="showView" params="creditcard" :fill="activeView === 'creditcard'" />

            <btn-rounded label="DOAÇÕES" event="showView" params="donate" :fill="activeView === 'donate'" />

          </div>
        </div>
      </div>
    </div>


    <div v-if="activeView === 'profile'">

      <div class="row">

        <div class="col-md-12">
          <div class="col-md-1">
            <button class="btn btn-rounded btn-fill"
              :class="[{' btn-success': !localReadonly}, {' btn-warning': localReadonly}]"
              style="padding-left: 10px; padding-right: 10px" v-on:click="unlock()">
              <i :class="[{'ti-unlock': !localReadonly}, {'ti-lock': localReadonly}]"></i>
            </button>
          </div>
          <div class="col-md-11" v-if="!localReadonly">
            <button class="btn btn-rounded btn-fill btn-wd"
              :class="[{' btn-success': isAdmin}, {' btn-error': !isAdmin}]"
              style="padding-left: 10px; padding-right: 10px" v-on:click="Checkadmin()">
              <font v-if="!isAdmin"> Não Admin </font>
              <font v-if="isAdmin"> Admin </font>
            </button>

            <button class="btn btn-rounded btn-fill btn-warning btn-wd" style="padding-left: 10px; padding-right: 10px"
              v-on:click="reset()" v-if="isActive">
              <font> Esqueceu a Senha</font>

            </button>

            <button class="btn btn-rounded btn-fill btn-danger btn-wd" style="padding-left: 10px; padding-right: 10px"
              v-on:click="desassociar()" v-if="isAssociate">
              <font> Desassociar</font>

            </button>


          </div>


          <div class="col-md-12">

            <client-form :data='data' :readonly="localReadonly" :edit=true event="saveClient" />
          </div>

        </div>
      </div>

    </div>

    <div v-if="activeView === 'salary'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <component-table eventName="selectSalary" :title="tableSalary.title" :sub-title="tableSalary.subTitle"
              :data="salaryList" :control="tableSalary.control" :columns="tableSalary.columns"
              :headers="tableSalary.headers" />
          </div>

          <salary-form :data='salary' event="saveSalary" eventNovo="newSalary" />
        </div>

      </div>
    </div>

    <div v-if="activeView === 'creditcard'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <component-table eventName="selectCreditCard" :title="tableCreditCard.title"
              :sub-title="tableCreditCard.subTitle" :data="data.UserCreditCards" :control="tableCreditCard.control"
              :columns="tableCreditCard.columns" :headers="tableCreditCard.headers" />
          </div>

          <credit-card-form :data='creditCard' event="saveCreditCard" />
        </div>

      </div>
    </div>

    <div v-if="activeView === 'donate'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <component-table :title="tableDonate.title" :sub-title="tableDonate.subTitle" :data="data.Donates" :control="tableDonate.control"
              :columns="tableDonate.columns" :headers="tableDonate.headers" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeView === 'endereco'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <component-table eventName="selectAddress" :title="tableAddress.title" :sub-title="tableAddress.subTitle"
              :data="data.Addresses" :control="tableAddress.control" :columns="tableAddress.columns"
              :headers="tableAddress.headers" />
          </div>

          <address-form :data='address' event="saveAddress" />
        </div>

      </div>
    </div>

    <div v-if="activeView === 'dependent'">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <component-table eventName="selectDependent" :title="tableDependent.title" :sub-title="tableDependent.subTitle"
              :data="data.UserDependents" :control="tableDependent.control" :columns="tableDependent.columns"
              :headers="tableDependent.headers" />
          </div>

          <!-- <dependent-form :data='dependent' event="saveDependent" /> -->
        </div>

      </div>
    </div>



  </div>
</template>

<script>
  import ClientCard from 'src/components/UIComponents/Cards/ClientCard.vue'
  import ClientForm from "src/components/UIComponents/Forms/ClientForm.vue";
  import SalaryForm from "src/components/UIComponents/Forms/SalaryForm.vue";
  import CreditCardForm from "src/components/UIComponents/Forms/CreditCardForm.vue";
  import formConfirmButton from "src/components/UIComponents/Inputs/formConfirmButton.vue";
  import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
  import { mapActions, mapGetters, mapState } from "vuex";
  import DependentForm from "src/components/UIComponents/Forms/DependentForm";
  import Notifications from "vue-notification";
  import "viewerjs/dist/viewer.css";
  import Viewer from "v-viewer";
  import Vue from "vue";
  import moment, { now } from 'moment';

  Vue.use(Notifications);
  Vue.use(Viewer);

  const headersDependent =      ["Nome", "Parentesco",    "Sexo", "Telefone",       "CPF", "RG", "Nascimento", "CEP", "Nome do Pai", "Nome da Mãe"];
  const tableColumnsDependent = ["name", "degreeKinship", "sex",  "formattedPhone", "cpf", "rg", "birthday",   "cep", "nameFather", "nameMother"];
  const controlDependent = [{
    event: "deleteDependent",
    class:"ti-trash btn btn-danger btn-sm",
  }]   

  const headersSalary = ["Valor", "Status", "Data"];
  const tableColumnsSalary = ["formattedValueCentavos", 
    {
      columnName: "inactived",
      logic: function (data, columnData) {
        if (data == '') {
          return 'Ativo'
        }
        return 'Inativo'
      }
    },
  {
      columnName: "createdAt",
      logic: function (data, columnData) {
        if (!data) {
          return ''
        }
        return moment.utc(data).utcOffset(0).format('DD/MM/YYYY HH:mm:ss');
      }
    }];
  const controlSalary = [{
    event: "deleteSalary",
    class:"ti-trash btn btn-danger btn-sm",
  }]   
  
  const headersCreditCard = ["/", "Bandeira", "Ultimos 4", "Titular", "Validade", "Data"];
  const tableColumnsCreditCard = [ 
    {
      columnName: "imageURL",
      logic: function (data, columnData) {
        if (!data) {
          return ''
        }
        return '<img src='+data+' style="width:32px; height: 32px">';
      }
    }, 
    "type", "last_four", "holder_name", "card_expiration",
    {
      columnName: "createdAt",
      logic: function (data, columnData) {
        if (!data) {
          return ''
        }
        return moment.utc(data).utcOffset(0).format('DD/MM/YYYY HH:mm:ss');
      }
    }];
  const controlCreditCard = [{
    event: "deleteCreditCard",
    class:"ti-trash btn btn-danger btn-sm",
  }]

  const headersDonate = ["Últimos 4", "Valor (R$)", "Data"];
  const tableColumnsDonate = [ 
    "last_four", "formattedValueCentavos",
    {
      columnName: "createdAt",
      logic: function (data, columnData) {
        if (!data) {
          return ''
        }
        return moment.utc(data).utcOffset(0).format('DD/MM/YYYY HH:mm:ss');
      }
    }];
  const controlDonate = []

export default {
  components: {
    ClientForm,
    formConfirmButton,
    ClientCard,
    DependentForm,
    ComponentTable,
    SalaryForm,
    CreditCardForm
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  computed: {
    ...mapState({
      user: ({ user }) => user.selected,
      salaryList: ({salary}) => salary.list
    })
  },
  watch: {
    $route: "initData"
  },
  methods: {
    ...mapActions(["updateUser", "getUser","authReset", "createAddress", "deleteAddress", "updateAddress", "getSalaryList", "createSalary", "updateSalary", "deleteSalary", "createCreditCard", "updateCreditCard", "deleteCreditCard", "rejectAprovation"]),
    ...mapGetters({
      sidebarFlag: "sidebarFlag"
    }),
    initData() {
      this.activeView = "profile";
      this.data = this.$route.params.id;
      this.verifyID();
    
      this.getSalaryList({UserId: this.data.id})
     
    },

    unlock() {
      if (this.sidebarFlag() === "ADMIN") {
        this.localReadonly = !this.localReadonly;
      } else {
        this.localReadonly = true;
      }
    },

    reset(){
    this.authReset(this.data)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: "Email com nova senha enviada para usuário!",
            position: "top center",
            type: "success"
          });
        
        })
        .catch(res => {});

    },
    formatDollar(num) {
      var p = (num / 100).toFixed(2).split(".");
      return (
        "R$" +
        p[0]
          .split("")
          .reverse()
          .reduce(function(acc, num, i, orig) {
            return num == "-" ? acc : num + (i && !(i % 3) ? "." : "") + acc;
          }, "") +
        "," +
        p[1]
      );
    },  
    Checkadmin() {
      this.data.isAdmin = !this.data.isAdmin;

      this.updateUser({"id": this.data.id, "isAdmin": this.data.isAdmin}).then(res=>{
      if (this.data.isAdmin) {
        this.isAdmin = true;
      } else {
        this.isAdmin = false;
      }
      })
    },
    Checkactive() {
        this.data.isActive = !this.data.isActive;

      this.updateUser({"id": this.data.id, "isActive": this.data.isActive}).then(res=>{
        if (this.data.isActive) {
        this.isActive = true;
      } else {
        this.isActive = false;
      }
      })

    },
    desassociar() {
      var json = {
        "id": this.data.id
      }
      
       this.rejectAprovation(json)
            .then(res => {
               this.$notify({
                group: "foo",
                title: "Sucesso",
                text: res.msg,
                position: "top center",
                type: "success"
              });

              this.data.isAssociate = !this.data.isAssociate;
              this.isAssociate = this.data.isAssociate

            })
            .catch(res => {
              this.$notify({
                group: "foo",
                title: res.msg, // "Criação.",
                text: res.info, //"Usuário criado com sucesso!",
                position: "top center",
                type: "error"
              });
            });

    },
    verifyID(){
        if(this.data == undefined){
            this.$router.push({
          name: "Usuários - Lista",
        });
        }else{
        this.isAdmin = this.data.isAdmin;
        this.isActive = this.data.isActive;
        this.isAssociate = this.data.isAssociate;
        }
    },

  },

  data() {
    return {
      localReadonly: false,
      isAdmin: false,
      isActive: false,
      isAssociate: false,
      data: null,
      dependent: {},
      address: {},
      salary: {},
      creditCard: {},
      readonly: true,
      activeView: 'profile',
       tableDependent: {
          title: "Dependentes",
          subTitle: "Lista de dependentes do usuário",
          headers: [...headersDependent],
          columns: [...tableColumnsDependent],
          control: [...controlDependent]
        },
        tableSalary: {
          title: "Salário",
          subTitle: "Lista de salarios do usuário",
          headers: [...headersSalary],
          columns: [...tableColumnsSalary],
          control: [...controlSalary]
        },
        tableCreditCard: {
          title: "Cartões de Credito",
          subTitle: "Lista de cartões do usuário",
          headers: [...headersCreditCard],
          columns: [...tableColumnsCreditCard],
          control: [...controlCreditCard]
        },
        tableDonate: {
          title: "Doações",
          subTitle: "Lista de doações realizadas pelo usuário",
          headers: [...headersDonate],
          columns: [...tableColumnsDonate],
          control: [...controlDonate]
        },
    };
  },

  created() {
    this.initData();
    this.localReadonly = this.readonly;

 this.$on("selectAddress", item => {
      this.address = item;
    });

     this.$on("selectCreditCard", item => {
      this.creditCard = item;
    });

  this.$on("selectSalary", item => {
      this.salary = item;
    });

    this.$on("showView", view => {
      this.activeView = view;
    });


    this.$on("saveClient", () => {
      this.updateUser(this.data)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
          this.localReadonly = true;
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
    });

     this.$on("saveAddress", () => {
       if(this.address.id){
      //  this.address.state = this.chooseState(this.address.abbreviation)

        this.updateAddress(this.address)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
          this.address = {};
          
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
       }else{
         this.address.UserId = this.data.id;
        //  this.address.state = this.chooseState(this.address.abbreviation)

      this.createAddress(this.address)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: "Operação realizada com sucesso!",
            position: "top center",
            type: "success"
          });
          this.data.Addresses.push(this.address)
          this.address = {};
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
       }
    });
  
this.$on("deleteAddress", item => {
  this.deleteAddress(item)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
         const index = this.data.Addresses.indexOf(item, 0);
          if (index > -1) {
              this.data.Addresses.splice(index, 1);
          }
        })
        .catch(res => {
           this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
    });


     this.$on("saveSalary", () => {
       if(this.salary.id){

        this.updateSalary(this.salary)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
          
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
       }else{
      this.salary.UserId = this.data.id;

      this.createSalary(this.salary)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: "Operação realizada com sucesso!",
            position: "top center",
            type: "success"
          });
          this.salaryList.push(res.info)
          this.salary = {};
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
       }
    });

    this.$on("newSalary", item => {
      this.salary = item
    })

    this.$on("deleteSalary", item => {
  this.deleteSalary(item)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
         const index = this.salaryList.indexOf(item, 0);
          if (index > -1) {
              this.salaryList.splice(index, 1);
          }
        })
        .catch(res => {
           this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
    });


 this.$on("saveCreditCard", () => {
       if(this.creditCard.id){

        this.updateCreditCard(this.creditCard)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
          this.creditCard = {};
          
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
       }else{
         this.creditCard.UserId = this.data.id;
        //  this.address.state = this.chooseState(this.address.abbreviation)

      this.createCreditCard(this.creditCard)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: "Operação realizada com sucesso!",
            position: "top center",
            type: "success"
          });
          console.log(res)
          this.data = res.user
          this.creditCard = {};
        })
        .catch(res => {
          this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
       }
    });

     this.$on("deleteCreditCard", item => {
  this.deleteCreditCard(item)
        .then(res => {
          this.$notify({
            group: "foo",
            title: "Sucesso",
            text: res.msg,
            position: "top center",
            type: "success"
          });
         const index = this.data.UserCreditCards.indexOf(item, 0);
          if (index > -1) {
              this.data.UserCreditCards.splice(index, 1);
          }
        })
        .catch(res => {
           this.$notify({
            group: "foo",
            title: res.msg,
            text: res.info,
            position: "top center",
            type: "error"
          });
        });
    });
  
  
  }
};
</script>
<style lang="scss" scoped>
.card-image {
  border: solid 1px white;
  padding: 15px;
  background-color: #f0f0f0;
}

.rotateimg90 {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.rotateimg180 {
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

.rotateimg270 {
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  transform: rotate(270deg);
}

.images {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Users/UserEdit.vue